export function headerShowHide() {
  const getHeight = (el) => {
    const styles = window.getComputedStyle(el);
    const height = el.offsetHeight;
    const borderTopWidth = parseFloat(styles.borderTopWidth);
    const borderBottomWidth = parseFloat(styles.borderBottomWidth);
    const paddingTop = parseFloat(styles.paddingTop);
    const paddingBottom = parseFloat(styles.paddingBottom);
    return height - borderBottomWidth - borderTopWidth - paddingTop - paddingBottom;
  }
  
  const header = document.getElementById('header');
  let prevScrollpos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  let isClickScrolling = false;
  let headerHeight = getHeight(header);
  let currentScTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

  if(header) {
    const SCROLL_HEADER_SHOWHIDE = () => {
      const currentScrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      if((currentScTop + headerHeight) < currentScrollPos || currentScrollPos < (currentScTop - headerHeight)) {
        if(!isClickScrolling && !header.classList.contains('nest-nav-active') && !document.body.classList.contains('is-click-scrolling')) {
          if (400 < currentScrollPos && prevScrollpos < currentScrollPos) {
            document.body.classList.add('header-hide');
          } else {
            document.body.classList.remove('header-hide');
          }
        }
      }
      prevScrollpos = currentScrollPos;
    }

    window.addEventListener('resize', SCROLL_HEADER_SHOWHIDE);
    window.addEventListener('orientationchange', SCROLL_HEADER_SHOWHIDE);
    let timeoutId = '';
    window.addEventListener('scroll', () => {
      SCROLL_HEADER_SHOWHIDE();

      clearTimeout(timeoutId) ;
      timeoutId = setTimeout( function () {
        currentScTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      }, 100) ;
    });
    SCROLL_HEADER_SHOWHIDE();
  }
}